// Exports
export default {
	"ModerationPopup": "ModerationPopup_HvhGl"
};
